export default __webpack_public_path__ + "static/media/about_s.37498faa.jpg";